<template>
    <base-modal name="create-product-list">
        <div class="p-8 flex justify-center">
            <div class="text-center">
                <p class="mb-4 text-2xl">{{ _('lists.create_list_header') }}</p>
                <div class="flex flex-wrap md:flex-nowrap justify-center">
                    <input
                        v-model="name"
                        :placeholder="_('lists.input_list_name_placeholder')"
                        class="w-full border border-black text-left bg-white px-4 py-2 mb-4 md:mb-0 md:mr-4"
                        @keydown.enter="create"
                        autofocus
                        ref="input"
                    >
                    <button @click.prevent="create" class="btn btn-small btn-primary w-full">{{ _('lists.create_list_button_label') }}</button>
                </div>
            </div>
        </div>
    </base-modal>
</template>
<script>
    import axios from 'axios'
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    export default {
        data() {
            return {
                name: '',
                product: null,
            }
        },

        mounted() {
            Event.listen('create-product-list.queue-product', (product) => this.queuedProduct = product)
        },

        computed: {
            ...mapGetters('general', ['_', 'isSv', 'currentViewport'])

        },

        methods: {
            ...mapActions('general', ['likeProduct', 'flashSuccess', 'flashError', 'createList']),
            ...mapMutations('modal', ['hideModal']),

            create() {
                this
                    .createList(this.name)
                    .then((list) => {
                        if (this.queuedProduct) {
                            this.likeProduct({list: list, product: this.queuedProduct});
                            this.flashSuccess(this._('lists.list_created_and_product_added'));
                        } else {
                            this.flashSuccess(this._('lists.list_created'));
                        }

                        this.name = '';
                        this.hideModal('create-product-list');
                    })
                    .catch((err) => {
                        console.log(err);
                        this.flashError(this._('lists.list_action_general_failure'));
                    })
            },
        }
    }
</script>
